var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 18.8889C15.5 19.5022 15.0211 20 14.4286 20C13.8361 20 13.3571 19.5022 13.3571 18.8889C13.3571 15.8256 10.9539 13.3333 8 13.3333C5.04607 13.3333 2.64286 15.8256 2.64286 18.8889C2.64286 19.5022 2.16393 20 1.57143 20C0.978929 20 0.5 19.5022 0.5 18.8889C0.5 14.6 3.86536 11.1111 8 11.1111C12.1346 11.1111 15.5 14.6 15.5 18.8889ZM8 2.22222C9.18179 2.22222 10.1429 3.21889 10.1429 4.44444C10.1429 5.67 9.18179 6.66667 8 6.66667C6.81821 6.66667 5.85714 5.67 5.85714 4.44444C5.85714 3.21889 6.81821 2.22222 8 2.22222ZM8 8.88889C10.3636 8.88889 12.2857 6.89556 12.2857 4.44444C12.2857 1.99333 10.3636 0 8 0C5.63643 0 3.71429 1.99333 3.71429 4.44444C3.71429 6.89556 5.63643 8.88889 8 8.88889Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.3623a909.svg";
export { ForwardRef as ReactComponent };